import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Home = () => {
  let navigate = useNavigate();

  const onSubscribe = (e) => {
    e.preventDefault();
  };

  return (
    <>
      {/* hero */}
      <section className="sm-hero">
        <Container>
          <Row className="align-items-center">
            <Col lg={6}>
              <div className="sm-hero-badge">
                <span className="sm-hero-badge-dot"></span>
                Fresh produce. Fair pricing. Direct connections.
              </div>

              <h1 className="sm-hero-title">
                Download and order now
              </h1>
              <p className="sm-hero-kicker">
                All of your fruit, veggie, plants, and more all in one app.
              </p>

              <p className="sm-hero-text">
                Don't have groceries? Missing an ingredient? GoCart is the
                only delivery app in Colombia that focuses on fruit
                producers, plant nurseries and local vendors in a single
                app. Fast and secure delivery to your door with all the
                freshest products Colombia has to offer.
              </p>

              <div className="sm-hero-cta">
                <a href="#marketplace" className="sm-btn sm-btn-primary">
                  Download now!
                </a>
              </div>
            </Col>

            <Col lg={6}>
              <div className="sm-hero-media">
                <span className="sm-blob sm-blob-primary"></span>
                <span className="sm-blob sm-blob-accent"></span>
                <img
                  src={require("../assets/images/right-man-img.png")}
                  alt="GoCart dashboard, app and delivery rider"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* vendors */}
      <section className="sm-vendors">
        <Container>
          <Row className="align-items-center">
            <Col lg={6}>
              <h2 className="sm-section-title">
                We have a growing list of vendors available!
              </h2>
              <p className="sm-cities">
                <span>Serving</span> Medellin <i>|</i> Bogota <i>|</i> Cali{" "}
                <i>|</i> Cartagena
              </p>
              <p className="sm-section-text">
                It's now easier than ever to get fresh produce and support
                local Colombians. Download the GoCart app on your mobile
                device and select your product from our marketplace. After
                placing your order, one of our delivery drivers will be
                assigned to pick up and deliver your products safely and
                quickly!
              </p>
              <div className="sm-hero-cta">
                <a href="#marketplace" className="sm-btn sm-btn-primary">
                  Download now!
                </a>
              </div>
            </Col>
            <Col lg={6}>
              <div className="sm-hero-media">
                <img
                  src={require("../assets/images/choose-img.png")}
                  alt="GoCart vendor dashboard"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* stats */}
      <section className="sm-stats-banner">
        <Container>
          <h2>See how we're serving Latin America</h2>
          <div className="sm-stats-row">
            <div className="sm-stat-pill">
              <p className="sm-stat-pill-value">100+</p>
              <p className="sm-stat-pill-label">Products Available</p>
            </div>
            <div className="sm-stat-pill">
              <p className="sm-stat-pill-value">1000+</p>
              <p className="sm-stat-pill-label">Active Users</p>
            </div>
            <div className="sm-stat-pill">
              <p className="sm-stat-pill-value">100+</p>
              <p className="sm-stat-pill-label">Active Farmers</p>
            </div>
            <div className="sm-stat-pill">
              <p className="sm-stat-pill-value">$50M+ COP</p>
              <p className="sm-stat-pill-label">Revenue Generated</p>
            </div>
          </div>
        </Container>
      </section>

      {/* how it works */}
      <section className="sm-services" id="services">
        <Container>
          <div className="sm-section-head text-center">
            <p className="sm-eyebrow">Want to work with GoCart?</p>
            <h2 className="sm-section-title">How GoCart Works</h2>
          </div>

          <Row className="align-items-center mt-5">
            <Col lg={6}>
              <ol className="sm-works-list">
                <li>
                  <span className="sm-works-num">1</span>
                  <div>
                    <p className="sm-works-title">Sign Up</p>
                    <p className="sm-works-sub">
                      Create your free account on GoCart and unlock access
                      to our platform.
                    </p>
                  </div>
                </li>
                <li>
                  <span className="sm-works-num">2</span>
                  <div>
                    <p className="sm-works-title">List Your Products</p>
                    <p className="sm-works-sub">
                      Showcase your harvests with stunning images and
                      detailed descriptions.
                    </p>
                  </div>
                </li>
                <li>
                  <span className="sm-works-num">3</span>
                  <div>
                    <p className="sm-works-title">Receive Orders</p>
                    <p className="sm-works-sub">
                      Sit back and relax as customers browse and purchase
                      your products through our marketplace.
                    </p>
                  </div>
                </li>
                <li>
                  <span className="sm-works-num">4</span>
                  <div>
                    <p className="sm-works-title">Track Deliveries</p>
                    <p className="sm-works-sub">
                      With our integrated tracking tools, monitor the
                      journey of your products from farm to doorstep.
                    </p>
                  </div>
                </li>
                <li>
                  <span className="sm-works-num">5</span>
                  <div>
                    <p className="sm-works-title">Get Paid</p>
                    <p className="sm-works-sub">
                      Receive secure payments directly into your account,
                      hassle-free.
                    </p>
                  </div>
                </li>
                <li>
                  <span className="sm-works-num">6</span>
                  <div>
                    <p className="sm-works-title">Grow Your Business</p>
                    <p className="sm-works-sub">
                      With GoCart, the sky's the limit — expand your
                      customer base and increase your profits with ease.
                    </p>
                  </div>
                </li>
              </ol>
            </Col>

            <Col lg={6}>
              <div className="sm-works-media">
                <img
                  src={require("../assets/images/process.png")}
                  alt="How GoCart works, from farm to doorstep"
                />
              </div>
            </Col>
          </Row>

          <div className="sm-works-cta">
            <button
              type="button"
              className="sm-btn sm-btn-primary"
              onClick={() => navigate("/signup")}
            >
              Start Selling Today
            </button>
          </div>
        </Container>
      </section>

      {/* testimonials */}
      <section className="sm-testimonials" id="testimonials">
        <Container>
          <div className="sm-section-head text-center">
            <p className="sm-eyebrow">Happy cultivators</p>
            <h2 className="sm-section-title">What they're talking about</h2>
          </div>

          <div className="sm-quote-card mt-5">
            <div className="sm-quote-photo">
              <img
                src={require("../assets/images/culti-man.png")}
                alt="Brenda G., local farm owner"
              />
            </div>
            <div className="sm-quote-body">
              <img
                className="sm-quote-mark"
                src={require("../assets/images/quote.png")}
                alt=""
              />
              <blockquote>
                Now that we had our meeting online, I am seeing so many
                amazingly beautiful opportunities for people to connect and
                have the exposure you have for them to sell their goods.
                All farm to table products. I love the concept and 100%
                believe in this.
              </blockquote>
              <div className="sm-quote-author">
                <div>
                  <p className="sm-author-name">Brenda G.</p>
                  <div className="sm-stars">
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>

      {/* marketplace in your pocket */}
      <section className="sm-mobile-app" id="marketplace">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="order-2 order-lg-1">
              <div className="sm-hero-media">
                <img
                  src={require("../assets/images/marketplace.png")}
                  alt="GoCart marketplace app"
                />
              </div>
            </Col>
            <Col lg={6} className="order-1 order-lg-2">
              <p className="sm-eyebrow">Your marketplace in your pocket</p>
              <h2 className="sm-section-title">
                Our marketplace in your pocket
              </h2>
              <p className="sm-section-text">
                Discover the ultimate convenience in sourcing fresh produce
                with GoCart! Our app revolutionizes the way you shop for
                fruits and veggies, bringing the market to your fingertips.
                Say goodbye to long queues and limited selections. With
                GoCart, you can browse, select, and purchase your favorite
                produce from local vendors instantly. Whether you're a
                health enthusiast, a culinary connoisseur, or simply
                seeking quality ingredients, GoCart ensures freshness and
                variety with just a few taps.
              </p>
              <div className="sm-store-buttons">
                <button type="button" className="sm-store-btn">
                  <i className="fa-brands fa-apple"></i>
                  <span>
                    <span className="sm-store-btn-kicker">Download on the</span>
                    <span className="sm-store-btn-name">App Store</span>
                  </span>
                </button>
                <button type="button" className="sm-store-btn">
                  <i className="fa-brands fa-google-play"></i>
                  <span>
                    <span className="sm-store-btn-kicker">Get it on</span>
                    <span className="sm-store-btn-name">Google Play</span>
                  </span>
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* market banner */}
      <section className="sm-market-banner">
        <img
          src={require("../assets/images/newslater.png")}
          alt="Fresh produce market stall"
        />
      </section>

      {/* newsletter */}
      <section className="sm-newsletter">
        <Container>
          <div className="sm-newsletter-box">
            <p className="sm-newsletter-eyebrow">Join our newsletter</p>
            <h2>Get timely updates from your products</h2>
            <form className="sm-newsletter-form" onSubmit={onSubscribe}>
              <input type="email" placeholder="Enter email address" required />
              <button type="submit">Subscribe</button>
            </form>
          </div>
        </Container>
      </section>
    </>
  );
};
export default Home;
